import { TrackCountOfAction } from '@/api/currentUser/commands';
import { useSendCommand } from '@/_core/cqrs/use';
import { Action } from '@/_core/fluxstore/types';
import { useLocalStorage } from 'vue-composable';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SetIsReleasePinned extends Action<StorymapState> {
    public static ACTION_TYPE = 'SetIsReleasePinned';

    public constructor(public id: string, public isPinned: boolean, public isReset: boolean = false) {
        super(SetIsReleasePinned.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SetIsReleasePinned): Promise<boolean> => {
    if (action.isPinned && !action.isReset) {
        useSendCommand(action, {
            createCommand: () => new TrackCountOfAction('RELEASE_PIN_COUNT'),
        });

        const { storage: hasAlreadyPinnedRelease } = useLocalStorage('_storiesonboard_hasAlreadyPinnedRelease', false);
        hasAlreadyPinnedRelease.value = true;
    }

    return true;
};

const reducer = (state: StorymapState, action: SetIsReleasePinned): void => {
    if (action.isPinned) {
        const pinnedRelease = state.releases.find((x) => x.isPinned);

        if (pinnedRelease) {
            pinnedRelease.isPinned = false;
        }

        state.hasAlreadyPinnedRelease = true;
    }

    const release = state.releases.find((x) => x.id === action.id);

    release.isPinned = action.isPinned;
};

//@ts-ignore
registerMiddleware(SetIsReleasePinned.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetIsReleasePinned.ACTION_TYPE, reducer);
